export enum OAuthErrorTypeEnum {
    InvalidClient = 'invalid_client',
    InvalidGrant = 'invalid_grant',
}
